import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import apiRoutes from '../../../app/api/routes';

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});
export const OFF_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE = 'offPremiseVehicleAccessRights';

export default ComposedComponent =>
  compose(
    connect(mapStateToProps),
    reduxFetch(({ organisationId }) => [
      {
        resource: OFF_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE,
        method: 'get',
        request: licensePlate => ({
          url: addParametersToUri(apiRoutes.offPremiseAccessRights({ organisationId }), {
            licensePlate,
            pageSize: 100,
          }),
        }),
      },
    ])
  )(props => <ComposedComponent {...props} />);
